import { ReactNode } from 'react';
import classNames from 'classnames';

export interface TopProps {
  children?: ReactNode;
  className?: string;
}
export const Top = ({ children, className, ...r }: TopProps) => {
  const classnames = classNames(
    'top-options',
    className
  );

  return (
    <div className={classnames} {...r}>
      {children}
    </div>
  );
};